import { UploadFile } from '@steelbuy/ts-shared';
import { SelectedFile } from '@steelbuy/ui-primitive';

export const getSelectedFiles = (files?: UploadFile[]) =>
    files?.map<SelectedFile>(({ documentId, meta: { fileName, size } }) => ({
        name: fileName,
        size,
        documentId,
    }));
